/**
 * @generated SignedSource<<bdec5eccb981e1667828c194cc3e8905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksFollowTargetEntityQuery$variables = {
  authorEntityIds: ReadonlyArray<string>;
  sectionEntityIds: ReadonlyArray<string>;
  topicApplicationId: string;
  topicEntityIds: ReadonlyArray<string>;
};
export type hooksFollowTargetEntityQuery$data = {
  readonly Author: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
      };
    }>;
  };
  readonly Section: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
      };
    }>;
  };
  readonly Topic: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
      };
    }>;
  };
};
export type hooksFollowTargetEntityQuery = {
  response: hooksFollowTargetEntityQuery$data;
  variables: hooksFollowTargetEntityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authorEntityIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionEntityIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicApplicationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicEntityIds"
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "authorEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "sectionEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v4/*: any*/)
],
v10 = [
  {
    "kind": "Variable",
    "name": "applicationId",
    "variableName": "topicApplicationId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "topicEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  (v4/*: any*/)
],
v11 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksFollowTargetEntityQuery",
    "selections": [
      {
        "alias": "Author",
        "args": (v5/*: any*/),
        "concreteType": "AuthorConnection",
        "kind": "LinkedField",
        "name": "authors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "Section",
        "args": (v9/*: any*/),
        "concreteType": "SectionConnection",
        "kind": "LinkedField",
        "name": "sections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "Topic",
        "args": (v10/*: any*/),
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hooksFollowTargetEntityQuery",
    "selections": [
      {
        "alias": "Author",
        "args": (v5/*: any*/),
        "concreteType": "AuthorConnection",
        "kind": "LinkedField",
        "name": "authors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthorEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "Section",
        "args": (v9/*: any*/),
        "concreteType": "SectionConnection",
        "kind": "LinkedField",
        "name": "sections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "Topic",
        "args": (v10/*: any*/),
        "concreteType": "TopicConnection",
        "kind": "LinkedField",
        "name": "topics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8cc2c7705f9c5408ec56b4012ec06e0f",
    "id": null,
    "metadata": {},
    "name": "hooksFollowTargetEntityQuery",
    "operationKind": "query",
    "text": "query hooksFollowTargetEntityQuery(\n  $authorEntityIds: [String!]!\n  $sectionEntityIds: [String!]!\n  $topicEntityIds: [String!]!\n  $topicApplicationId: String!\n) {\n  Author: authors(filter: {entityIds: $authorEntityIds}, first: 10) {\n    edges {\n      node {\n        entityId\n        name\n        id\n      }\n    }\n  }\n  Section: sections(filter: {entityIds: $sectionEntityIds}, first: 10) {\n    edges {\n      node {\n        entityId\n        name\n        id\n      }\n    }\n  }\n  Topic: topics(filter: {entityIds: $topicEntityIds}, first: 10, applicationId: $topicApplicationId) {\n    edges {\n      node {\n        entityId\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "147d27744c7a3259253c1009f5fee35f";

export default node;
